import React, { useState, useEffect, useContext } from 'react';
import { Button, Grid, Tab, Tabs, Typography, Box, FormControlLabel, Checkbox } from '@mui/material';
import { useForm } from 'react-hook-form';
import { ModalGeneral, Tabla, AutocompleteForm } from 'ui-component';
import ExportExcel from 'ui-component/Tabla/ExportarExcel/Excel';
import Services from './Components/services';
import LayautContext from 'Context/ContextLayaut';
import { register } from 'serviceWorker';
import ModalDetalleRespuestas from './Components/ModalDetalleRespuestas';

const ReporteGeneral = ({ permisos, opcion }) => {
    const { control, getValues, setValue, watch } = useForm();
    const services = Services();
    const context = useContext(LayautContext);

    const [tiposCurso, setTiposCurso] = useState([]);
    const [checked, setChecked] = useState(false);
    const [listaCursos, setListaCursos] = useState([]);
    const [listaActividades, setListaActividades] = useState([]);
    const [datosReporteCurso, setDatosReporte] = useState([]);
    const [muestraCurso, setMuestraCurso] = useState(false);
    const [sesiones, setSesiones] = useState([]);
    const [arrSesion, setArrSesion] = useState([]);
    const [examenActual, setExamenActual] = useState(null);
    const [columnasMostrar, setColumnasMostrar] = useState([]);

    const [examenesTodos, setExamenesTodos] = useState([]);
    const [tiposActividadCat, setTiposActividadCat] = useState([]);
    const [tipoActividadSel, setTipoActividadSel] = useState(null);

    const [intentoBuscar, setIntentoBuscar] = useState(false);
    const [sinResultados, setSinResultados] = useState(false);
    const [mostrarBtnDescargaSeguimiento, setMostrarBtnDescargaSeguimiento] = useState(false);
    const [reporteSeguimientoExcel, setReporteSeguimientoExcel] = useState({ columnas: [], registros: [], fileName: 'reporte_seguimiento' });
    const filtroTipoCurso = watch('tipoCurso');
    const filtroCurso = watch('itemCurso');
    const filtroTipoActividad = watch('tipoActividadForm');
    const filtroActividad = watch('itemActividad');

    const getDataExcelConResumen = () => {
        const columnas = reporteSeguimientoExcel.columnas || [];
        if (!checked || !columnas.length) return [];

        const resumen = [
            ['Clasificación de curso', filtroTipoCurso?.nClasificacioncurso || ''],
            ['Curso', filtroCurso?.titulo || ''],
            ['Tipo de actividad', filtroTipoActividad?.ntipoActividad || ''],
            ['Actividad', filtroActividad?.titulo || '']
        ];

        const dataResumen = resumen.map((item) => [
            { value: item[0] },
            { value: item[1] }
        ]);

        const dataTabla = (reporteSeguimientoExcel.registros || []).map((row) =>
            columnas.map((col) => ({
                value: ['money', 'cantidad'].includes(col.type) ? Number(row[col.name]) || 0 : row[col.name] || '',
                style: {}
            }))
        );

        const filaInicioTabla = 7;
        const indiceFilaInicioTabla = filaInicioTabla - 1;
        const filasResumen = dataResumen.length;
        const yStepsTabla = Math.max(0, indiceFilaInicioTabla - filasResumen);

        return [
            {
                xSteps: 0,
                ySteps: 0,
                columns: [],
                data: dataResumen
            },
            {
                xSteps: 2,
                ySteps: yStepsTabla,
                columns: columnas.map((col) => ({ title: col.label, width: { wpx: 80 } })),
                data: dataTabla
            }
        ];
    };

    const columnsReporte = [
        { label: 'número de empleado', name: 'num_empleado', filtrar: true },
        { label: 'nombre', name: 'nombre_persona', filtrar: true },
        { label: 'tipo', name: 'tipo_puesto', filtrar: true },
        { label: 'departamento', name: 'nom_area', filtrar: true },
        { label: 'área', name: 'nom_subarea', filtrar: true },
        { label: 'puesto', name: 'nom_puesto', filtrar: true },
        { label: 'promedio', name: 'promedio', filtrar: true },
        { label: 'porcentaje de avance', name: 'avance', filtrar: true }
    ];

    const columnsReporteAct = [
        { label: 'fecha de realización', name: 'fechaCreacion', filtrar: true },
        { label: 'número de empleado', name: 'num_empleado', filtrar: true },
        { label: 'nombre', name: 'nombre_persona', filtrar: true },
        { label: 'departamento', name: 'nom_area', filtrar: true },
        { label: 'área', name: 'nom_subarea', filtrar: true },
        { label: 'puesto', name: 'nom_puesto', filtrar: true },
        { label: 'nombre actividad', name: 'titulo', filtrar: true },
        { label: 'intento', name: 'numIntento', filtrar: true }
        // { label: 'Actividad', name: 'titulo', filtrar: true },
        // { label: 'intentos por evaluación', name: 'numRespondidos', filtrar: true },
        // { label: 'Promedio Actividad', name: 'calificacion', filtrar: true },
        // { label: 'Progreso actividad', name: 'avance', filtrar: true }
    ];

    const apruebaCurso = (row) => {
        const curso = getValues('itemCurso')?.idCurso;
        context.modal.confirmar({
            open: true,
            title: 'Validar aprobación del curso',
            text: 'Si el colaborador ha completado todas sus evaluaciones puede aprobar el curso',
            aceptar: () => {
                context.modal.cerrar();
                services.validarAprobacion(
                    (data) => {
                        console.log('aprobado', data);
                    },
                    {
                        idCurso: curso,
                        idColaborador: row.idColaborador
                    }
                );
            }
        });
    };

    const verDetalle = (row) => {
        const esEncuestaDetalle = tipoActividadSel ? [7, 11].includes(Number(tipoActividadSel.idTipoActividad)) : false;

        services.getDetalleRespuestaCalificacion(
            (res) => {
                context.formulario.abrir({
                    open: true,
                    titulo: 'Detalle de respuestas',
                    width: 'md',
                    propsForm: { data: res.detalle, esEncuesta: esEncuestaDetalle },
                    formulario: ModalDetalleRespuestas,
                    isVer: true
                });
            },
            { idCalificacionDetalle: row.idCalificacionDetalle }
        );
    };

    const acciones = [
        { label: 'Verificar aprobación', onClick: apruebaCurso, enabled: (row) => permisos.aprCur && Number(row.numAvance) >= 100 }
    ];

    const accionesFilaActividad = [{ label: 'Ver detalle', onClick: verDetalle, enabled: () => true }];

    const handleChangeCheck = (event) => {
        const isChecked = event.target.checked;
        setChecked(isChecked);
        setIntentoBuscar(false);
        setSinResultados(false);
        setMostrarBtnDescargaSeguimiento(false);
        setReporteSeguimientoExcel({ columnas: [], registros: [], fileName: 'reporte_seguimiento' });

        if (!isChecked) {
            setTipoActividadSel(null);
            setExamenActual(null);
            setListaActividades([]);
            setValue('tipoActividadForm', null);
            setValue('itemActividad', null);
        }
    };

    const handleChangeTipo = (obj) => {
        setIntentoBuscar(false);
        setSinResultados(false);
        setDatosReporte([]);
        setMostrarBtnDescargaSeguimiento(false);
        setReporteSeguimientoExcel({ columnas: [], registros: [], fileName: 'reporte_seguimiento' });

        if (obj) {
            services.buscaCursoByTipo(
                (ct) => {
                    setListaCursos(ct.cursos || []);
                    setMuestraCurso(true);
                },
                {
                    tipoBuscar: obj.idClasificacionCurso
                }
            );
        } else {
            setMuestraCurso(false);
        }
    };

    const buscaActividades = (obj) => {
        if (obj) {
            services.buscaActividades(
                (ct) => {
                    setListaActividades(ct.actividades || []);
                },
                {
                    idSesion: obj.idSesion
                }
            );
        } else {
            setMuestraCurso(false);
        }
    };

    const filtraSesionesCurso = (obj) => {
        if (obj) {
            let arr = sesiones.filter((x) => x.idCurso == obj.idCurso);
            setArrSesion([...arr]);
        }
    };

    const buscaExamenesCurso = (obj) => {
        setTipoActividadSel(null);
        setExamenActual(null);
        setListaActividades([]);
        setValue('tipoActividadForm', null);
        setValue('itemActividad', null);
        setIntentoBuscar(false);
        setSinResultados(false);
        setDatosReporte([]);
        setMostrarBtnDescargaSeguimiento(false);
        setReporteSeguimientoExcel({ columnas: [], registros: [], fileName: 'reporte_seguimiento' });

        if (obj) {
            services.buscaExamenesCurso(
                (ct) => {
                    setExamenesTodos(ct.examenes || []);
                },
                {
                    idCurso: obj.idCurso,
                    area: opcion
                }
            );
        } else {
            setExamenesTodos([]);
        }
    };

    const handleChangeTipoActividad = (obj) => {
        setExamenActual(null);
        setValue('itemActividad', null);
        setIntentoBuscar(false);
        setSinResultados(false);
        setMostrarBtnDescargaSeguimiento(false);
        setReporteSeguimientoExcel({ columnas: [], registros: [], fileName: 'reporte_seguimiento' });

        if (obj) {
            setTipoActividadSel(obj);
            const filtrados = examenesTodos.filter((ex) => Number(ex.idTipoActividad) === Number(obj.idTipoActividad));
            setListaActividades(filtrados);
        } else {
            setTipoActividadSel(null);
            setListaActividades([]);
        }
    };

    const buscaReporte = () => {
        setIntentoBuscar(true);
        setSinResultados(false);
        setMostrarBtnDescargaSeguimiento(false);
        setReporteSeguimientoExcel({ columnas: [], registros: [], fileName: 'reporte_seguimiento' });

        if (checked == true) {
            if (!tipoActividadSel || !examenActual) {
                setDatosReporte([]);
                return;
            }

            const act = examenActual;
            const esEncuesta = [7, 11].includes(Number(act.idTipoActividad));

            let arr = [...columnsReporteAct];

            arr.push({
                label: 'reactivos totales',
                name: 'totalReactivos',
                filtrar: true
            });

            if (esEncuesta) {
                arr.push({
                    label: 'reactivos contestados',
                    name: 'reactivosContestados',
                    filtrar: true
                });
            } else {
                // Examen / Examen completo
                arr.push({
                    label: 'reactivos acertados',
                    name: 'aciertos',
                    filtrar: true
                });
                arr.push({
                    label: 'reactivos incorrectos',
                    name: 'desaciertos',
                    filtrar: true
                });
                arr.push({
                    label: 'promedio',
                    name: 'calificacion',
                    filtrar: true
                });
            }

            setColumnasMostrar([...arr]);

            services.getReporteCursoAct(
                (ct) => {
                    setMostrarBtnDescargaSeguimiento(true);

                    if (ct && ct.registros && ct.registros.length > 0) {
                        setDatosReporte(ct.registros);
                        setSinResultados(false);
                    } else {
                        setDatosReporte([]);
                        setSinResultados(true);
                    }
                },
                {
                    idDetAct: act.idDetalleActividad
                }
            );

            services.getReporteCursoActDetalle(
                (ct) => {
                    setReporteSeguimientoExcel({
                        columnas: ct?.columnas || [],
                        registros: ct?.registros || [],
                        fileName: ct?.fileName || 'reporte_seguimiento_detallado'
                    });
                },
                {
                    idDetAct: act.idDetalleActividad,
                    idTipoActividad: tipoActividadSel?.idTipoActividad || act.idTipoActividad,
                    nTipoActividad: tipoActividadSel?.ntipoActividad || ''
                },
                { backdrop: false }
            );
        } else {
            setColumnasMostrar([...columnsReporte]);

            const tipo = getValues('tipoCurso')?.idClasificacionCurso;
            const curso = getValues('itemCurso')?.idCurso;

            if (!tipo || !curso) {
                setDatosReporte([]);
                return;
            }

            services.getReporteCurso(
                (ct) => {
                    if (ct && ct.registros && ct.registros.length > 0) {
                        setDatosReporte(ct.registros);
                        setSinResultados(false);
                    } else {
                        setDatosReporte([]);
                        setSinResultados(true);
                    }
                    setMostrarBtnDescargaSeguimiento(false);
                    setReporteSeguimientoExcel({ columnas: [], registros: [], fileName: 'reporte_seguimiento' });
                },
                {
                    idCurso: curso,
                    area: opcion
                }
            );
        }
    };

    useEffect(() => {
        setColumnasMostrar([...columnsReporte]);
        services.grupoInt((ct) => {
            setTiposCurso(ct.tiposCursos || []);
            setSesiones(ct.sesiones || []);
            setTiposActividadCat(ct.tiposActividad || []);
        });
    }, []);

    return (
        <>
            <Grid container spacing={2}>
                <Grid item md={12} container spacing={2} alignItems="center">
                    <Grid item xs={3}>
                        <AutocompleteForm
                            label="Clasificación de curso"
                            control={control}
                            name="tipoCurso"
                            rules={{ required: { value: true, message: 'Campo requerido' } }}
                            options={tiposCurso}
                            optionSelected={{ label: 'nClasificacioncurso', id: 'idClasificacionCurso' }}
                            onChange={handleChangeTipo}
                        />
                    </Grid>
                    {muestraCurso == true && (
                        <Grid item xs={3}>
                            <AutocompleteForm
                                id="listaCursos"
                                label="Curso"
                                control={control}
                                name="itemCurso"
                                rules={{ required: { value: true, message: 'Campo requerido' } }}
                                options={listaCursos}
                                optionSelected={{ label: 'titulo', id: 'idCurso' }}
                                onChange={buscaExamenesCurso}
                            />
                        </Grid>
                    )}

                    <Grid item xs={3}>
                        <FormControlLabel
                            control={<Checkbox checked={checked} onChange={handleChangeCheck} name="checked" color="secondary" />}
                            label="Buscar por actividad"
                        />
                    </Grid>

                    {checked && (
                        <Grid item xs={12} container spacing={2}>
                            <Grid item xs={3}>
                                <AutocompleteForm
                                    id="tipoActividadForm"
                                    label="Tipo de actividad"
                                    control={control}
                                    name="tipoActividadForm"
                                    rules={{ required: { value: true, message: 'Campo requerido' } }}
                                    options={tiposActividadCat}
                                    optionSelected={{ label: 'ntipoActividad', id: 'idTipoActividad' }}
                                    onChange={handleChangeTipoActividad}
                                />
                                {intentoBuscar && !tipoActividadSel && (
                                    <Typography variant="caption" color="error" sx={{ ml: 1.5 }}>
                                        Por favor seleccione un tipo de actividad
                                    </Typography>
                                )}
                            </Grid>

                            {tipoActividadSel && (
                                <Grid item xs={3}>
                                    <AutocompleteForm
                                        id="listaActividades"
                                        label="Actividad"
                                        control={control}
                                        name="itemActividad"
                                        rules={{ required: { value: true, message: 'Campo requerido' } }}
                                        options={listaActividades}
                                        optionSelected={{ label: 'titulo', id: 'idDetalleActividad' }}
                                        onChange={(obj) => {
                                            setExamenActual(obj || null);
                                            setIntentoBuscar(false);
                                            setSinResultados(false);
                                        }}
                                    />
                                    {intentoBuscar && !examenActual && (
                                        <Typography variant="caption" color="error" sx={{ ml: 1.5 }}>
                                            Por favor seleccione una actividad
                                        </Typography>
                                    )}
                                </Grid>
                            )}
                        </Grid>
                    )}

                    {muestraCurso == true && (
                        <Grid item xs={3}>
                            <Button variant="contained" color="primary" onClick={buscaReporte}>
                                Buscar
                            </Button>
                        </Grid>
                    )}

                    {mostrarBtnDescargaSeguimiento && checked && (
                        <Grid item xs={3}>
                            <ExportExcel
                                id="btnDescargarReporteSeguimiento"
                                data={reporteSeguimientoExcel.registros}
                                columns={reporteSeguimientoExcel.columnas}
                                fileName={reporteSeguimientoExcel.fileName}
                                buttonLabel=""
                                tooltipTitle="Exportar reporte de seguimiento completo a Excel"
                                disabled={!reporteSeguimientoExcel.columnas?.length}
                                dataSet={getDataExcelConResumen()}
                            />
                        </Grid>
                    )}

                    {sinResultados && (
                        <Grid item xs={12}>
                            <Typography variant="body2" color="error">
                                No se encontraron registros para esta búsqueda
                            </Typography>
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <Tabla
                            rows={datosReporteCurso}
                            columns={columnasMostrar}
                            accionesFila={checked ? accionesFilaActividad : acciones}
                            columnKey="num_empleado"
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default ReporteGeneral;
